import Loader from 'components/Loader'
import React from 'react'

interface OptionsProps {
  isSending: boolean
  withQr: () => void
  withoutQr: () => void
  buyQrView: () => void
}

const Options: React.FC<OptionsProps> = ({ isSending, withQr, withoutQr, buyQrView }) => {
  return (
    <div className="options">

      {isSending
        ? <Loader type='full' />
        : <>
          <div className="button button--normal" onClick={withQr}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Mam tabliczkę QR</h2>
            <p>Mozesz dodać osobę do istniejącej tabliczki</p>
          </div>

          <div className="button button--normal" onClick={withoutQr}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Dodaj osobę do mapy pomników</h2>
            <p>Stwórz własną listę pomników<br></br>
              które odwiedzasz 1 Listopada.</p>
          </div>

          <div className="button button--add" onClick={buyQrView}>
            <div className="arrowWrap">
              <i className="icon icon--arrow-right"></i>
            </div>
            <h2>Kup tabliczkę QR na pomnik</h2>
            <p>Stwórz profil zmarłego, aby Twoi bliscy mogli:</p>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--heart"></i>
              </div>
              <div className="content">
                <h3>Wspomnieć zmarłego</h3>
                <p>Obejrzeć jego profil, zdjęcia oraz filmy</p>
              </div>
            </div>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--candle"></i>
              </div>
              <div className="content">
                <h3>Zapalić znicz</h3>
                <p>Dowiesz się kto odwiedził pomnik</p>
              </div>
            </div>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--book"></i>
              </div>
              <div className="content">
                <h3>Dodać wpis do księgi kondolencyjnej</h3>
                <p>Bliscy dodadzą wpis, zdjęcia oraz filmy</p>
              </div>
            </div>
            <div className="element">
              <div className="iconWrap">
                <i className="icon icon--add-location"></i>
              </div>
              <div className="content">
                <h3>Zapiszą lokalizację</h3>
                <p>Zapiszą pomnik do listy odwiedzanych 1 listopada</p>
              </div>
            </div>
          </div>
        </>}
    </div>
  )
}

export default Options